<template>
  <AdminLayout>
    <Head title="Create New Package" />

    <SuccessFlash></SuccessFlash>

    <div class="form bg-gray-100 rounded-lg shadow p-10">
      <form-request
        class="form bg-gray-100 rounded-bl-lg rounded-br-lg shadow p-10"
        :action="createRoute"
        :errors="errors"
        v-slot="{ updateForm, errors, submit }"
      >
        <details-form
          title="Create New Package"
          :errors="errors"
          :locations="locations"
          :spaces="spaces"
          :products="products"
          :lineages="lineages"
          :initial-product-id="productId"
          @update:modelValue="updateForm"
        />
        <accept
          text="Create"
          @click="submit()"
        />
      </form-request>
    </div>
  </AdminLayout>
</template>

<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head } from '@inertiajs/vue3'
import SuccessFlash from '@/Partials/Alerts/SuccessFlash'
import DetailsForm from './Form/_details'
import Accept from '@/Components/Buttons/Accept'
import FormRequest from '@/Components/Forms/FormRequest'

export default {
  components: {
    FormRequest,
    Accept,
    DetailsForm,
    AdminLayout,
    Head,
    SuccessFlash
  },

  props: {
    /**
     * The server url we use to create a new package
     */
    createRoute: {
      type: String,
      required: true
    },

    /**
     * A list of errors found in the form
     */
    errors: {
      type: Object,
      default() {
        return {}
      }
    },

    locations: {
      type: Array,
      default() {
        return []
      }
    },
    spaces: {
      type: Array,
      default() {
        return []
      }
    },

    /**
     * A list of products that belong to this company
     */
    products: {
      type: Array,
      default() {
        return []
      }
    },

    /**
     * A key val list of lineages for selection
     */
    lineages: {
      type: Object,
      default() {
        return {}
      }
    },

    /**
     * The initial product ID to create a package for
     */
    productId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      form: {}
    }
  }
}
</script>
